import { Icon } from "@thetreep/ui";
import { getColor } from "@utils/colors";

type ToasterProps = {
  type?: "success" | "error" | "info" | "warning";
  children: React.ReactNode;
  className?: string;
};

const COLORS = {
  success: "success-strong",
  error: "error-strong",
  info: "info-strong",
  warning: "warning-strong",
};

const ICONS = {
  success: <Icon src="check_circle_line" color={getColor(COLORS.success)} />,
  error: <Icon src="alert_line" color={getColor(COLORS.error)} />,
  info: <Icon src="information_line" color={getColor(COLORS.info)} />,
  warning: <Icon src="warning_line" color={getColor(COLORS.warning)} />,
};

export const BannerMessage = ({
  type = "info",
  children,
  className,
}: ToasterProps) => {
  return (
    <div
      className={`border bg-white rounded-lg  p-6 flex items-center gap-3  ${className}`}
      style={{ borderColor: getColor(COLORS[type]) }}
    >
      {ICONS[type]}
      <span className="flex-1 text-gray-800">{children}</span>
    </div>
  );
};
